<div class="container">
  <app-ref
    [image]="{
      src: 'assets/img/references/Chipolbrok.png',
      alt: 'Chipolbrok',
      link: 'https://opennet.pl'
    }"
    company="Chipolbrok"
    pdf="assets/pdf/references/Chipolbrok.PDF"
  >
    <ul>
      <li>{{ "references.chipolbrok.1" | translate }}</li>
      <li>{{ "references.chipolbrok.2" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/PGE.png',
      alt: 'PGE',
      link: 'https://PGE.pl'
    }"
    company="PGE"
    pdf="assets/pdf/references/PGE.pdf"
  >
    <ul>
      <li>{{ "references.pge.1" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/Senson.webp',
      alt: 'Senson',
      link: 'https://senson.pl'
    }"
    company="Senson"
    pdf="assets/pdf/references/Senson.PDF"
  >
    <ul>
      <li>{{ "references.senson.1" | translate }}</li>
      <li>{{ "references.senson.2" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/Klus.png',
      alt: 'Kluś',
      link: 'https://klusdesign.pl'
    }"
    company="Kluś"
    pdf="assets/pdf/references/Klus.PDF"
  >
    <ul>
      <li>{{ "references.klus.1" | translate }}</li>
      <li>{{ "references.klus.2" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/Opennet.png',
      alt: 'Opennet',
      link: 'https://opennet.pl'
    }"
    company="Opennet"
    pdf="assets/pdf/references/Opennet.pdf"
  >
    <ul>
      <li>{{ "references.opennet.1" | translate }}</li>
      <li>{{ "references.opennet.2" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/regio.png',
      alt: 'Polregio',
      link: 'https://polregio.pl/pl/'
    }"
    company="Polregio"
    pdf="assets/pdf/references/Polregio1.pdf"
  >
    <ul>
      <li>{{ "references.polregio.1" | translate }}</li>
      <li>{{ "references.polregio.2" | translate }}</li>
      <li>{{ "references.polregio.3" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/MSWiA.png',
      alt: 'MSWiA',
      link: 'https://www.gov.pl/web/mswia'
    }"
    company="MSWiA"
    pdf="assets/pdf/references/MSWiA.PDF"
  >
    <ul>
      <li>{{ "references.mswia.1" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/regio.png',
      alt: 'Polregio',
      link: 'https://polregio.pl/pl/'
    }"
    company="Polregio"
    pdf="assets/pdf/references/Polregio.pdf"
  >
    <ul>
      <li>{{ "references.polregio.1" | translate }}</li>
      <li>{{ "references.polregio.2" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/Orange.png',
      alt: 'Orange',
      link: 'https://www.orange.pl/'
    }"
    company="Orange"
    pdf="assets/pdf/references/Orange.pdf"
  >
    <ul>
      <li>{{ "references.orange.1" | translate }}</li>
      <li>{{ "references.orange.2" | translate }}</li>
      <li>{{ "references.orange.3" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/Orange.png',
      alt: 'Orange',
      link: 'https://www.orange.pl/'
    }"
    company="Orange"
    pdf="assets/pdf/references/Orange1.pdf"
  >
    <ul>
      <li>{{ "references.orange1.1" | translate }}</li>
      <li>{{ "references.orange1.2" | translate }}</li>
      <li>{{ "references.orange1.3" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/Tuatara.png',
      alt: 'Tuatara',
      link: 'https://tuatara.pl/pl/home/'
    }"
    company="Tuatara"
    pdf="assets/pdf/references/Tuatara.pdf"
  >
    <ul>
      <li>{{ "references.tuatara.1" | translate }}</li>
      <li>{{ "references.tuatara.2" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/poczta.png',
      alt: 'Poczta Polska',
      link: 'https://www.poczta-polska.pl/'
    }"
    company="Poczta Polska"
    pdf="assets/pdf/references/PocztaPolska.pdf"
  >
    <ul>
      <li>{{ "references.pp.1" | translate }}</li>
      <li>{{ "references.pp.2" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/poczta.png',
      alt: 'Poczta Polska',
      link: 'https://www.poczta-polska.pl/'
    }"
    company="Poczta Polska"
    pdf="assets/pdf/references/PocztaPolska1.pdf"
  >
    <ul>
      <li>{{ "references.pp1.1" | translate }}</li>
      <li>{{ "references.pp1.2" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/prs.png',
      alt: 'PRS',
      link: 'https://prs.pl/'
    }"
    company="PRS"
    pdf="assets/pdf/references/prs.pdf"
  >
    <ul>
      <li>{{ "references.prs.1" | translate }}</li>
      <li>{{ "references.prs.2" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/Orange.png',
      alt: 'Orange',
      link: 'https://www.orange.pl/'
    }"
    company="Orange"
    pdf="assets/pdf/references/Orange2.pdf"
  >
    <ul>
      <li>
        {{ "references.orange2.1" | translate }}<br />{{
          "references.orange2.2" | translate
        }}
      </li>
      <li>{{ "references.orange2.3" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/Orange.png',
      alt: 'Orange',
      link: 'https://www.orange.pl/'
    }"
    company="Orange"
    pdf="assets/pdf/references/Orange3.pdf"
  >
    <ul>
      <li>
        {{ "references.orange3.1" | translate }}
      </li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/poczta.png',
      alt: 'Poczta Polska',
      link: 'https://www.poczta-polska.pl/'
    }"
    company="Poczta Polska"
    pdf="assets/pdf/references/Pocztapolska2.pdf"
  >
    <ul>
      <li>{{ "references.pp2.1" | translate }}</li>
      <li>{{ "references.pp2.2" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/plus.png',
      alt: 'Plus',
      link: 'https://www.plus.pl/'
    }"
    company="Plus"
    pdf="assets/pdf/references/Plus.pdf"
  >
    <ul>
      <li>{{ "references.plus.1" | translate }}</li>
      <li>{{ "references.plus.2" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/regio.png',
      alt: 'Polregio',
      link: 'https://polregio.pl/pl/'
    }"
    company="Polregio"
    pdf="assets/pdf/references/PR.png"
  >
    <ul>
      <li>{{ "references.polregio1.1" | translate }}</li>
      <li>{{ "references.polregio1.2" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/eurofoam.png',
      alt: 'EuroFoam',
      link: 'https://www.neveon.com/en/'
    }"
    company="EuroFoam"
    pdf="assets/pdf/references/EuroFoam.pdf"
  >
    <ul>
      <li>{{ "references.eurofoam.1" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/baltykgaz.png',
      alt: 'Bałtykgaz',
      link: 'https://www.baltykgaz.pl/pl'
    }"
    company="Bałtykgaz"
    pdf="assets/pdf/references/BaltykGaz.pdf"
  >
    <ul>
      <li>
        {{ "references.baltykgaz.1" | translate }}
      </li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/Orange.png',
      alt: 'Orange',
      link: 'https://www.orange.pl/'
    }"
    company="Orange"
    pdf="assets/pdf/references/Orange4.pdf"
  >
    <ul>
      <li>{{ "references.orange4.1" | translate }}</li>
      <li>{{ "references.orange4.2" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/Energa_operator.jpg',
      alt: 'Energa Operator',
      link: 'https://energa-operator.pl/'
    }"
    company="Energa Operator"
    pdf="assets/pdf/references/Energa.pdf"
  >
    <ul>
      <li>{{ "references.energa.1" | translate }}</li>
      <li>{{ "references.energa.2" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/lukosz.jpg',
      alt: 'Łukosz',
      link: 'http://www.lukosz.pl/pl'
    }"
    company="Łukosz"
    pdf="assets/pdf/references/Lukosz.pdf"
  >
    <ul>
      <li>{{ "references.lukosz.1" | translate }}</li>
      <li>{{ "references.lukosz.2" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/Softprodukt.jpg',
      alt: 'SoftProdukt',
      link: 'https://www.softprodukt.com.pl/'
    }"
    company="SoftProdukt"
    pdf="assets/pdf/references/SoftProdukt.pdf"
  >
    <ul>
      <li>{{ "references.softprodukt.1" | translate }}</li>
      <li>{{ "references.softprodukt.2" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/atos.png',
      alt: 'Atos',
      link: 'https://atos.net/pl/polska'
    }"
    company="Atos"
    pdf="assets/pdf/references/Atos.pdf"
  >
    <ul>
      <li>{{ "references.atos.1" | translate }}</li>
      <li>{{ "references.atos.2" | translate }}</li>
      <li>{{ "references.atos.3" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/RCB.png',
      alt: 'RCB',
      link: 'https://www.gov.pl/web/rcb'
    }"
    company="RCB"
    pdf="assets/pdf/references/RCB.pdf"
  >
    <ul>
      <li>{{ "references.rcb.1" | translate }}</li>
      <li>{{ "references.rcb.2" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/ARP.png',
      alt: 'ARP',
      link: 'https://arp.pl/pl/'
    }"
    company="ARP"
    pdf="assets/pdf/references/ARP.pdf"
  >
    <ul>
      <li>{{ "references.arp.1" | translate }}</li>
      <li>{{ "references.arp.2" | translate }}</li>
    </ul>
  </app-ref>

  <app-ref
    [image]="{
      src: 'assets/img/references/Orange.png',
      alt: 'Orange',
      link: 'https://www.orange.pl/'
    }"
    company="Orange"
    pdf="assets/pdf/references/Orange5.pdf"
  >
    <ul>
      <li>{{ "references.orange5.1" | translate }}</li>
      <li>{{ "references.orange5.2" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/Orange.png',
      alt: 'Orange',
      link: 'https://www.orange.pl/'
    }"
    company="Orange"
    pdf="assets/pdf/references/Orange6.pdf"
  >
    <ul>
      <li>{{ "references.orange6.1" | translate }}</li>
      <li>{{ "references.orange6.2" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/BGK1.jpg',
      alt: 'BGK',
      link: 'https://www.bgk.pl/'
    }"
    company="BGK"
    pdf="assets/pdf/references/BGK.pdf"
  >
    <ul>
      <li>{{ "references.bgk.1" | translate }}</li>
    </ul>
  </app-ref>
  <app-ref
    [image]="{
      src: 'assets/img/references/prokom.jpg',
      alt: 'Prokom',
      link: 'https://polregio.pl/pl/'
    }"
    company="Prokom"
    pdf="assets/pdf/references/Prokom.pdf"
  >
    <ul>
      <li>{{ "references.prokom.1" | translate }}</li>
    </ul>
  </app-ref>
</div>
